export enum AutomationSourceEnum {
    automacao_comunicacao = 'automacao_comunicacao',
    // automacao_classificacao = 'automacao_classificacao',
    automacao_pipeline = 'automacao_pipeline',
    automacao_nps = 'automacao_nps',
    automacao_indica = 'automacao_indica',
    automacao_agenda = 'automacao_agenda',
    automacao_agenda_2 = 'automacao_agenda_2',
    automacao_pdv = 'automacao_pdv',
}
